export enum RecorderStatus {
  A_CONFIRMAR = 'A_CONFIRMAR',
  CONFIRMADO = 'CONFIRMADO',
  NAO_CONFIRMADO = 'NAO_CONFIRMADO',
  NAO_IDENTIFICADO = 'NAO_IDENTIFICADO',
}

export enum FilterEmbeddedStatus {
  ALL = 'ALL',
  EMBARCADA = 'EMBARCADA',
  NAO_EMBARCADA = 'NAO_EMBARCADA',
}

export enum RecorderStatusId {
  A_CONFIRMAR = 1,
  CONFIRMADO = 2,
  NAO_CONFIRMADO = 3,
  NAO_IDENTIFICADO = 4,
}

export enum ConfidenceThreshold {
  LOW = 75,
  MEDIUM = 90,
}

export enum SearchConfig {
  DEBOUNCE_TIME = 400,
  MIN_SEARCH_LENGTH = 0,
  UPDATE_DELAY = 3000,
}

export enum PaginationConfig {
  DEFAULT_PAGE_SIZE = 10,
  MIN_ROWS = 5,
  FIRST_PAGE = 1,
}
